/**
 * Contractors API — list, get, create, update, delete; contacts, payments, credentials.
 */

import { apiFetch } from './core'

export const contractors = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/contractors/${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/contractors/${id}`),
    /** Журнал карточки страницей: что менялось, с чего на что (или что сделали), кто и когда.
     *  Курсор непрозрачен — он приходит из прошлого ответа и возвращается как есть. */
    history: (id, { cursor, limit } = {}) => {
        const qs = new URLSearchParams()
        if (cursor) qs.set('cursor', cursor)
        if (limit) qs.set('limit', String(limit))
        const q = qs.toString()
        return apiFetch(`/contractors/${id}/history${q ? `?${q}` : ''}`)
    },
    create: (data) => apiFetch('/contractors', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    update: (id, data) => apiFetch(`/contractors/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    delete: (id) => apiFetch(`/contractors/${id}`, { method: 'DELETE' }),
    /** Перевод в штат: сотрудник заводится и подрядчик закрывается одним движением.
     *  Двумя отдельными действиями это и давало двойную оплату месяца перехода. */
    transitionToEmployee: (id, data) => apiFetch(`/contractors/${id}/transition-to-employee`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    addContact: (id, data) => apiFetch(`/contractors/${id}/contacts`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    removeContact: (id, contactId) => apiFetch(`/contractors/${id}/contacts/${contactId}`, { method: 'DELETE' }),
    addPayment: (id, data) => apiFetch(`/contractors/${id}/payments`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    updatePayment: (id, paymentId, data) => apiFetch(`/contractors/${id}/payments/${paymentId}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    confirmPayment: (id, paymentId) => apiFetch(`/contractors/${id}/payments/${paymentId}/confirm`, {
        method: 'POST',
    }),
    removePayment: (id, paymentId) => apiFetch(`/contractors/${id}/payments/${paymentId}`, { method: 'DELETE' }),
    addCredential: (id, data) => apiFetch(`/contractors/${id}/credentials`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    removeCredential: (id, credentialId) => apiFetch(`/contractors/${id}/credentials/${credentialId}`, { method: 'DELETE' }),

    // Учётка подрядчика: логин и временный пароль показываются ОДИН раз —
    // сервер их не хранит в открытом виде и повторно не отдаёт.
    provisionAccount: (id) => apiFetch(`/contractors/${id}/account`, { method: 'POST' }),

    // Задачи ведёт руководитель отдела; здесь — только просмотр по подрядчику.
    tasks: (id) => apiFetch(`/contractor-tasks?contractor_id=${id}`),
}
